<template>
  <div class="password-reset-expired container">
    <div class="my-5">
      <b-row align-h="center" align-v="center">
        <b-col cols="8" md="6" lg="6">
          <b-card no-body class="v2_box_teal">
            <b-card-header class="v2_box_teal_header">
              <div class="mb-0 v2_font_size_20">
                Password Reset Token {{ isResent ? 'sent' : 'is expired' }}.
              </div>
            </b-card-header>
            <b-card-body
              class="v2_color_black  v2_font_size_18 mt-2"
            >
              <p v-if="!isResent">
                The password token is expired. Tokens expire in
                {{ resetPasswordTimeoutSetting || 24 }} hours, please try again.
              </p>
              <p v-else>{{ message }}</p>
            </b-card-body>
            <b-card-footer class="v2_bg_transparent">
              <p v-if="!isResent" class="text-right">
                <b-button
                  variant="v2_white"
                  class="width_140"
                  @click="onCancel"
                >
                  Cancel
                </b-button>
                <b-button
                  variant="v2_primary"
                  class="ml-1 width_140"
                  @click="onReset"
                >
                  <template v-if="!sendLoading">Resend</template>
                  <template v-else>
                    <b-spinner small />
                    <span>Sending...</span>
                  </template>
                </b-button>
              </p>
              <p v-else class="text-right">
                <b-button
                  variant="v2_primary"
                  class="ml-1 width_140"
                  @click="onCancel"
                >
                  Close
                </b-button>
              </p>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Api from '../../../../providers/Api';

export default {
  name: 'ExpiredForm',
  props: {
    token: String,
  },
  data: function () {
    return {
      sendLoading: false,
      isResent: false,
      message: '',
      resetPasswordTimeoutSetting: null,
    };
  },
  created: function () {
    Api.getResetPasswordTimeoutSetting().then((s) => {
      this.resetPasswordTimeoutSetting = s;
    });
  },
  methods: {
    onCancel: function () {
      this.$router.push('/');
    },
    onReset: function () {
      this.sendLoading = true;
      Api.resendPasswordReset(this.token)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 3000 });
          this.message = response.data.message;
          this.isResent = true;
        })
        .catch((error) => {
          this.$toasted.error(error.response.data.message, { duration: 3000 });
        })
        .finally(() => {
          this.sendLoading = false;
        });
    },
  },
};
</script>

<style scoped></style>
